<template>
    <v-dialog v-model="dialog" max-width="70vw" @click:outside="closeModal()">
        <v-card>
            <v-card-title class="headline"><strong>Vui lòng xác nhận thông tin (Chú ý thời hạn, Sản phẩm, Giá tiền...)</strong></v-card-title>

            <div v-if="!_.isEmpty(dataDialog)">
                <v-row>
                    <v-col cols="12" sm="12" class="order-products-wrapper" style="overflow: auto">
                        <v-simple-table class="table-layout table-small-screen">
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th><b>Tên sản phẩm</b></th>
                                    <th style="width: 100px">Số lượng</th>
                                    <th>Đơn giá</th>
                                    <th><b>Thành tiền</b></th>
                                    <th style="white-space: nowrap;">Tên con sử dụng</th>
                                    <th style="width: 164px !important; max-width: 162px !important;"><b>Thời hạn</b></th>
                                </tr>
                                </thead>
                                <tbody>
                                  <template v-for="(product, index) in dataDialog.products">
                                      <tr :key="index" style="height: 20px">

                                        <td>
                                            <b>{{getProductName(product.productId, product.productType)}}</b>
                                        </td>
                                        <td>
                                            {{product.quantity}}
                                        </td>
                                        <td>
                                            {{formatPrice(product.price)}}
                                        </td>
                                        <td>
                                            <b>{{formatPrice(product.intoMoney)}}<u>đ</u></b>
                                        </td>
                                        <td>
                                            {{getChildName(product.customerId)}}
                                        </td>
                                        <td>
                                          <template v-if="!product.orderType">
                                              <template v-if="product.activeType === 1 || product.activeType === 3">
                                                  <b>{{dataDialog.listEndDate[product.customerId][product.productId].end_date}} <span v-if="dataDialog.listEndDate[product.customerId][product.productId].checkDeposit"> tháng</span></b>
                                              </template>
                                              <template v-if="product.activeType === 2">
                                                 <template v-if="checkName(product.productId)">
                                                     <b>{{dataDialog.listEndDate[product.customerId][product.productId].end_date}} <span v-if="dataDialog.listEndDate[product.customerId][product.productId].checkDeposit"> tháng</span></b>
                                                 </template>
                                                  <template v-else>
                                                      <b><i>Tự kích hoạt</i></b>
                                                      <div style="color: red; font-style: italic">
                                                          ( Thời hạn chờ kích hoạt tối đa là 1 năm )
                                                      </div>
                                                  </template>
                                              </template>
                                          </template>
                                            <template v-else>
                                                <b>{{dataDialog.listEndDate[product.customerId][product.productId].end_date}} <span v-if="dataDialog.listEndDate[product.customerId][product.productId].checkDeposit"> tháng</span></b>
                                            </template>
                                        </td>
                                      </tr>
                                      <template v-if="getListEndDateLearnType(product.productId) && getListEndDateLearnType(product.productId).endDateLearnType.length">
                                          <tr v-for="(productLearnType, indexLearnType) in getListEndDateLearnType(product.productId).endDateLearnType" :key="indexLearnType+'learn-type'" style="height: 30px;padding-left: 5px;">
                                              <td colspan="5" style="text-align: left !important;padding-left: 33px;border-bottom: none !important;">
                                                  <div class="d-flex align-center" style="column-gap: 5px;">
                                                      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M1.1875 17.6429C1.1875 18.3935 1.71816 19 2.375 19H8.3125V12.2143H1.1875V17.6429ZM10.6875 19H16.625C17.2818 19 17.8125 18.3935 17.8125 17.6429V12.2143H10.6875V19ZM17.8125 5.42857H16.2502C16.4803 4.9154 16.625 4.3471 16.625 3.73214C16.625 1.67522 15.1592 0 13.3594 0C11.8156 0 10.8174 0.903348 9.53711 2.89665C8.25684 0.903348 7.25859 0 5.71484 0C3.91504 0 2.44922 1.67522 2.44922 3.73214C2.44922 4.3471 2.59023 4.9154 2.82402 5.42857H1.1875C0.530664 5.42857 0 6.03504 0 6.78571V10.1786C0 10.5518 0.267188 10.8571 0.59375 10.8571H18.4062C18.7328 10.8571 19 10.5518 19 10.1786V6.78571C19 6.03504 18.4693 5.42857 17.8125 5.42857ZM5.71113 5.42857C4.89102 5.42857 4.22676 4.66942 4.22676 3.73214C4.22676 2.79487 4.89102 2.03571 5.71113 2.03571C6.44961 2.03571 6.99512 2.17567 8.90625 5.42857H5.71113ZM13.3594 5.42857H10.1643C12.0717 2.18415 12.6023 2.03571 13.3594 2.03571C14.1795 2.03571 14.8438 2.79487 14.8438 3.73214C14.8438 4.66942 14.1795 5.42857 13.3594 5.42857Z" fill="#454545"/>
                                                      </svg>
                                                      <div class="mt-1" style="font-style: italic; font-weight: 500;margin-left: 3px;">Tặng thêm hạn: {{ listProductType(productLearnType.learnType) }}</div>
                                                  </div>
                                              </td>
                                              <td style="font-weight: 500;font-style: italic;border-bottom: none !important;">
                                                  <template v-if="product.activeType === 1 || product.activeType === 3">
                                                      <div v-if="dataDialog.listEndDate[product.customerId][product.productId].checkDeposit">
                                                          (  {{ productLearnType.endMonth }} tháng )
                                                      </div>
                                                      <div v-else>
                                                          ( {{ productLearnType.endMonth
                                                          ? getLearnTypeDate(dataDialog.listEndDate[product.customerId][product.productId].end_date, productLearnType.endMonth)
                                                          : formatDateVN(productLearnType.endDate) }} )
                                                      </div>
                                                  </template>
                                              </td>
                                          </tr>
                                      </template>
                                  </template>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td colspan="3" style="padding-left: 50px">
                                        <tr>
                                            <td class="table-footer-label"><b>Tổng giá trị đơn hàng:</b></td>
                                            <td class="table-footer-value"><b>{{formatPrice(totalPrice)}}</b></td>
                                        </tr>
                                        <tr v-if="dataDialog.restPrice ">
                                            <td class="table-footer-label"><b>Tiền cọc:</b></td>
                                            <td class="table-footer-value"><b style="color: #219653">{{formatPrice(dataDialog.restPrice)}}</b></td>
                                        </tr>
                                        <tr v-if="dataDialog.needMoney">
                                            <td class="table-footer-label"><b>Cần thanh toán:</b></td>
                                            <td class="table-footer-value"><b style="color: #FD1F6D">{{formatPrice(dataDialog.needMoney)}}</b></td>
                                        </tr>
                                        <tr>
                                            <td class="table-footer-label"><b>Hình thức thanh toán:</b></td>
                                            <td class="table-footer-value"><b>{{dataDialog.paymentType}}</b></td>
                                        </tr>
                                    </td>
                                    <td colspan="3">
                                        <tr>
                                            <td class="table-footer-label"><b>SĐT:</b></td>
                                            <td class="table-footer-value" colspan="2">{{dataDialog.shippingAddress.phone}} - {{dataDialog.shippingAddress.receiver}}</td>
                                        </tr>
                                        <tr v-if="dataDialog.paymentType == 'COD'">
                                            <td class="table-footer-label"><b>Địa chỉ:</b></td>
                                            <td class="table-footer-value" colspan="3">{{dataDialog.shippingAddress.detailAddress}}, {{dataDialog.shippingAddress.xaName}} {{dataDialog.shippingAddress.huyenName}} {{dataDialog.shippingAddress.tinhName}}</td>
                                        </tr>
                                    </td>
                                </tr>
                                </tfoot>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                        color="success"
                        @click="orderAction()"
                        style="float: right; font-size: 14px"
                        v-if="checkEndDate"
                        :loading="loading"
                        :disabled="loading"
                >
                    Đồng ý
                </v-btn>
                <v-card-text class="text-center text-red" v-else>Ngày hết hạn sản phẩm không đúng!</v-card-text>
                <v-btn
                        color="primary"
                        text
                        @click="closeModal()"
                        style="float: right; font-size: 14px"
                >
                    Hủy bỏ
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory'
import {ADDITIONAL_INGREDIENTS} from "@/helpers/constants";
import * as moment from "moment";
const AddressRepository = RepositoryFactory.get('address')

export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        dialog: {
            type: Boolean,
            default: false
        },
        childCustomers: {
            type: Array,
            default: () => {[]}
        },
        courseRegisters: {
            type: Array,
            default: () => {[]}
        },
        dataDialog: {
            type: Object,
            default: () => {{}}
        },
        provinces: {
            type: Array,
            default: () => {[]}
        },
        checkEndDate: {
            type: Boolean,
            default: true
        },
        listProductLearnType: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        totalPrice() {
            return  _.sumBy(this.dataDialog.products, 'intoMoney')
        }
    },
    methods: {
        checkName(productId) {
            const findProduct = this.courseRegisters.find(item => item.id == productId)
            return  findProduct.name.toLowerCase().indexOf('gia hạn') >= 0
        },
        getListEndDateLearnType(id) {
            return this.listProductLearnType.find(item => item.productId == id)
        },
        getLearnTypeDate(day, month) {
              return moment(day, 'DD/MM/YYYY').add(month, "months").format('DD/MM/YYYY');
        },
        formatDateVN(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '';
        },
        listProductType(data) {
            if(data.length) {
               const listDataName = []
                data.forEach(item => {
                   const data = ADDITIONAL_INGREDIENTS.find(data => data.id === item)
                    if(data) {
                        listDataName.push(data.name)
                    }
                })
                return listDataName.slice(0, -1).join(', ') + (listDataName.length > 1 ? ', ' : '') + listDataName[listDataName.length - 1];
            }
            return ''
        },
        closeModal() {
            this.$emit('closeModal')
        },
        getProductName(id, type) {
            let product = this.courseRegisters.find(item => item.idTemp == (type + '-' + id))
            if (product) {
                return product.name
            } else {
                return ''
            }
        },
        getChildName(id) {
            let child = this.childCustomers.find(item => item.id == id)
            if (child) {
                return child.fullName
            } else {
                return ''
            }
        },
        orderAction() {
            this.$emit('orderAction')
        }
    }
}
</script>

<style scoped>
.table-footer-label {
    font-size: 14px;
    text-align: left;
}
.table-footer-value {
    font-size: 14px;
    text-align: left;
}
b {
    font-weight: bold;
}
.text-red {
    color: red;
}
</style>